module.exports = __webpack_public_path__ + "static/img/ic_success.cd09ec8d.png";